// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!../node_modules/@unibuddy/patron/dist/styles.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    font-family:
        "Nunito",
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        "Roboto",
        "Oxygen",
        "Ubuntu",
        "Cantarell",
        "Fira Sans",
        "Droid Sans",
        "Helvetica Neue",
        sans-serif;
}

body {
    margin: 0;
    padding: 0;
}

* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;IACI;;;;;;;;;;;;kBAYc;AAClB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,sBAAsB;AAC1B","sourcesContent":["@import \"@unibuddy/patron/dist/styles.css\";\n\n:root {\n    font-family:\n        \"Nunito\",\n        -apple-system,\n        BlinkMacSystemFont,\n        \"Segoe UI\",\n        \"Roboto\",\n        \"Oxygen\",\n        \"Ubuntu\",\n        \"Cantarell\",\n        \"Fira Sans\",\n        \"Droid Sans\",\n        \"Helvetica Neue\",\n        sans-serif;\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n}\n\n* {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
